<template>
  <div  style='width:100%;height:100%'>
     <iframe style='width: 100%; height: 100%; border: none; display: block;' :src="$route.query.path" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style>
* {
  overflow-wrap: break-word;
  word-wrap: break-word; /* 兼容旧浏览器 */
}
</style>